import { useRequestStore } from "entities/Request";
import api from "shared/api";

class CurrencyExchangeService {
  getExchange([url, amount, currency], options) {
    return api
      .post(
        url,
        {
          application_id: useRequestStore.getState().request.id,
          amount: amount.toString(),
          base_currency: currency,
          local_currency: useRequestStore.getState().request.local_currency,
        },
        options
      )
      .then((response) => response.data.data);
  }
}

export default new CurrencyExchangeService();
